import React from 'react';
import { useUser } from 'store/User/Context';

import { HeaderStyle, LegendList, SectionBox } from 'components/analysis/AnalysisSaleList';
import BarWrapper from 'components/common/BarWrapper';

interface AreaRangeSquareMeterBarsProps {
    averagePriceByArea: { name: string; bar1: number; bar2: number; }[];
}

export const AreaRangeSquareMeterBars = ({ averagePriceByArea }: AreaRangeSquareMeterBarsProps) => {
    const { user } = useUser();

    return (
        <SectionBox data-pdf-section>
            <HeaderStyle>
                <h2>Cena m² według przedziałów powierzchni</h2>
                <LegendList darkMode={user.isDarkMode}>
                    <li>Średnia cena za m² brutto [PLN]</li>
                    <li>Mediana ceny za m² brutto [PLN]</li>
                </LegendList>
                <BarWrapper className="avg-price-area" barData={averagePriceByArea}/>
            </HeaderStyle>
        </SectionBox>
    );
};
